<template>
  <svg
    role="img"
    :class="`ic--${size || 'small'} ${onButtonClick ? 'cursor-pointer' : ''} ${color ? 'ic--' + color : 'ic--grey-semi-dark'} ${classes || ''}`"
    @click="onButtonClick ? onButtonClick($event) : null"
  >
    <use :xlink:href="'#' + name" />
  </svg>
</template>

<script>
export default {
  name: 'TrSvgIcon',
  props: ['name', 'size', 'classes',
    'color', 'onButtonClick']
};
</script>